﻿import {translation} from "@2d-front-monorepo/core";
import {AddressComponent, PermitResult, Residencies, Tariffs, Vehicles, Zones} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {getGlobalContext} from "../../../hooks/getGlobalContext";
import getResidencyHiddenFields from "../../../hooks/getResidencyHiddenFields";
import {usePermits} from "../../../hooks/usePermits";

export default function PermitTariffZone({permit}: { permit: PermitResult }): JSX.Element {
	const {installation} = getGlobalContext();
	const permits = usePermits();
	const residency = Residencies.getChanged(permits, permit.residency);
	const vehicles = Vehicles.getChanged(permits, permit.vehicles);
	const tariff = Tariffs.get(installation, permit.tariffId);
	const zone = Zones.get(installation, residency == null || residency.original.entity.zoneId == null ? permit.parkingLocation.zoneId : residency.original.entity.zoneId);
	const hiddenResidencyFields = getResidencyHiddenFields(installation, residency, permit.category);

	return (
		<div className="grid padded">
			<dl className="title-desc col-1of4">
				<dt>{translation(PermitTranslations.zone)}</dt>
				<dd>{zone.name || zone.id}</dd>
			</dl>

			<dl className="title-desc col-1of4">
				<dt>{translation(PermitTranslations.permit_tariff)}</dt>
				<dd>{tariff.title}</dd>
			</dl>

			{residency && <dl className="title-desc col-1of4">
                <dt>{translation(PermitTranslations.address)}</dt>
                <dd>
                    <AddressComponent value={residency.original.entity}
                                      hiddenEntityProperties={hiddenResidencyFields}/>
                </dd>
            </dl>}

			{vehicles.length > 0 &&
                <dl className="title-desc col-1of4">
                    <dt>{translation(PermitTranslations.vehicles)}</dt>
                    <dd className={"vehicles__list"}>
						{vehicles.map((v) => <span className="tabular-nums" key={v.original.entity.plate}>{v.original.entity.plate}</span>)}
                    </dd>
                </dl>}
		</div>
	);
}
